import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { RootStore } from "../root-store";
import { App } from "./app";
import { BaseModel } from "./base-model";
import { ProjectMember } from "./project-member";
import { User } from "./user";

export class ReleaseNote{
	@observable id: number;
	@observable text: string = "";
	@observable releaseDate: string = "";

	constructor(data : any = {}) {
		this.fromJSON(data);
	}

	@action updateProperty(name: string, value: any){
		this[name] = value;
	}

	@action fromJSON(data : any = {}){
		if(data.id){
			this.id = data.id;
		}
		if(data.text){
			this.text = data.text;
		}
		if(data.releaseDate){
			this.releaseDate = data.releaseDate;
		}
	}

	toString(){
		return JSON.stringify(this);
	}

}





// WEBPACK FOOTER //
// ./src/stores/models/releasenote.ts